#### Rate limiting

On the 30th of November 2024, rate limiting will be introduced to the SEEK API. This will improve system stability by protecting against abuse and misuse.

Rate limits are applied per query, mutation or attachment download endpoint.
General rate limits are applied across the API to prevent denial of service and should not be triggered in general operation.
Specific rate limits may apply to certain operations, such as those that are particularly resource-intensive.

The rate limits have been designed with typical usage patterns in mind.
No impact is anticipated to any existing integrations.

When a rate limit is exceeded on a GraphQL query or mutation, the SEEK API will return a `RATE_LIMITED` error code.
Similarly, when a rate limit is exceeded on an attachment download endpoint, the SEEK API will return a `429 Too Many Requests` status code.
We recommend that you update your software to handle these error scenarios gracefully.
Refer to the [GraphQL error response] documentation for more information on how to handle errors.

If you consistently encounter rate limiting or are planning to significantly increase your request volume, [contact SEEK’s support team].
We’ll work with you to resolve the issue and adjust rate limits if necessary.

[contact seek’s support team]: https://au.employer.seek.com/contactus
[GraphQL error response]: /graphql/error-responses
